import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NumberInput } from '../../Inputs';
import AbstractControl from '../AbstractControl';
import '../css/number-input.css';

class NumberControl extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    value: PropTypes.number,
    style: PropTypes.object,
    focus: PropTypes.bool,
    lockedState: PropTypes.bool,
    disabledState: PropTypes.bool,
    isShowArrow: PropTypes.bool,
    required: PropTypes.bool,
    requiredBlue: PropTypes.bool,
    allowBlankField: PropTypes.bool,
    hint: PropTypes.string,
    hintLink: PropTypes.string,
    label: PropTypes.string,
    errorText: PropTypes.string,
    className: PropTypes.string,
    parentClassName: PropTypes.string,
    tooltipText: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    valueType: PropTypes.string,
    ariaLabel: PropTypes.string,
    allowNegativeValue: PropTypes.bool,
    commitOnBlur: PropTypes.bool,
  };

  static defaultProps = {
    isShowArrow: true,
  };

  render() {
    const className = classNames(
      {
        'number-input-component': true,
        'with-arrows': this.props.isShowArrow,
      },
      this.props.className
    );

    const inputAbstractProps = {
      hint: this.props.hint,
      hintLink: this.props.hintLink,
      style: this.props.style,
      label: this.props.label,
      errorText: this.props.errorText,
      required: this.props.required,
      requiredBlue: this.props.requiredBlue,
      disabledState: this.props.disabledState,
      tooltipText: this.props.tooltipText,
      parentClassName: this.props.parentClassName,
      className: className,
      labelFor: this.props.id,
    };

    return (
      <AbstractControl {...inputAbstractProps}>
        <NumberInput
          id={this.props.id}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
          onKeyDown={this.props.onKeyDown}
          disabled={this.props.lockedState || this.props.disabledState}
          value={this.props.value}
          doFocus={this.props.focus}
          showScroller={this.props.isShowArrow}
          allowNullValue={this.props.allowBlankField}
          forceNegativeValue={this.props.valueType === 'negative'}
          minValue={this.props.min}
          maxValue={this.props.max}
          ariaLabel={this.props.ariaLabel}
          allowNegativeValue={this.props.allowNegativeValue}
          commitOnBlur={this.props.commitOnBlur}
        />
      </AbstractControl>
    );
  }
}

export default NumberControl;
